export default "__VITE_PUBLIC_ASSET__c69dbfc8__"